import "core-js/stable";
import "regenerator-runtime/runtime";
import "isomorphic-fetch";
import 'nodelist-foreach-polyfill';
import React from 'react';
import PropTypes from 'prop-types';
import render from '@rmb185/react-renderhelper';
import CustomLazyLoad from '../components/CustomLazyLoad';

const containers = document.querySelectorAll('[data-component-type]');


class ModuleLoader extends React.Component {

  static defaultProps = {
    moduleName: PropTypes.string,
    config: PropTypes.object,
  }

  state = {
    module: null,
  }

  componentDidMount = () => {
    import(`js/components/${this.props.moduleName}`).then((Module) => {

      if (/(127\.0\.0\.1)|(localhost)/.test(window.location.hostname)) {
        console.log(this.props.moduleName, this.props.config);
      }

      this.setState({
        module: <Module.default {...this.props.config} />,
      })

    }).catch((err) => {
      console.trace(err, this.props.moduleName);
    })
  }

  render() {
    return this.state.module ? this.state.module : <div style={{ height: '100vh' }} />;
  }

}

function getModuleName(moduleName) {
  if (/SiteSearch/.test(moduleName)) {
    moduleName = "Search/" + moduleName;
  }
  if (/IntroHero|LeftAlignedHero|CenteredCard|LeftAlignedCard|LeftAlignedPrefooter|CenteredPrefooter/.test(moduleName)) {
    moduleName = "GenericBanner/" + moduleName;
  }
  if (/ProductHero|ProductIntro|Features|AllProducts|ProductCarousel|Specifications/.test(moduleName)) {
    moduleName = "Products/" + moduleName;
  }
  if (/Applications|Accessories|ApplicationCategorySelector|ApplicationCategoryList|ApplicationSummary/.test(moduleName)) {
    moduleName = "Applications/" + moduleName;
  }
  if (/FAQs|ContactCards|ContactForm/.test(moduleName)) {
    moduleName = "Contact/" + moduleName;
  }
  return moduleName;
}

function isLazyLoadRequired(moduleName, index) {
  if (/(Footer)/.test(moduleName))
    return false;
  var currentPage = document.querySelector('body');
  if (currentPage.classList.contains("productdetail"))
    return false;//ignore lazy load for product detail page -- Fix for GitHub#378
  return index > 4;//ignore lazy load for first three components - Fix for GitHub#198
}
function trackClickPath() {
  var clickPath = sessionStorage.getItem("ClickPath");
  if (clickPath) {
    clickPath += '\n' + window.location.pathname
  }
  else
    clickPath = '\n' + window.location.pathname;
  sessionStorage.setItem('ClickPath', clickPath);
}

trackClickPath();

containers.forEach((el, i) => {
  let config = {},
    clsName = el.dataset.componentType;

  config = el.dataset.config || '{}';
  let isLazyLoad = isLazyLoadRequired(clsName, i);
  config = JSON.parse(config);
  clsName = getModuleName(clsName);
  if (isLazyLoad) {
    render(
      <CustomLazyLoad height={500}>
        <ModuleLoader config={config} moduleName={clsName} />
      </CustomLazyLoad>,
      el
    );
  } else {
    if (/Footer/.test(clsName)) {
      //merge main navigation config object with footer
      var ctrlFooter = document.querySelector('[data-component-type="MainNavigation"]')
      let mainNavConfig = ctrlFooter.dataset.config || '{}';
      mainNavConfig = JSON.parse(mainNavConfig);
      config = { ...mainNavConfig, ...config }
    }
    render(<ModuleLoader config={config} moduleName={clsName} />, el);
  }

});
